import {Component, Input} from '@angular/core';
import {LocaleService} from '../../../services/locale/locale.service';
import {Formats} from '../../../constants/formats';
import {Proposal} from '../../../model/proposal/proposal';

@Component({
    selector: 'app-insurance-contract-detail-previous-damages',
    templateUrl: './insurance-contract-detail-previous-damages.component.html',
    standalone: false
})
export class InsuranceContractDetailPreviousDamagesComponent {

  @Input() insuranceContract: Proposal;

  Formats = Formats;

  constructor(public readonly localeService: LocaleService,
  ) {
  }

}
